import { UploadIdentificationDtoIn } from '../../generated';
import { UploadedFile } from '../../model/UploadedFile';

export const fromUploadToGenerated = (upload: UploadedFile): UploadIdentificationDtoIn => {
  return {
    id: upload.id,
    uploadType: upload.category
  }
}
